import React from 'react';
import useFetch from '../../../../components/hooks/useFetch';
import { abreAlertaDialog } from '../../../../components/modal/AlertaDialog';
import {
  GRUPO_EXCLUIR
} from '../../../../services/permissoesRecebidas.js';

function FormExcluirGrupo({
  acaoCancelar,
  acaoFechar,
  grupoSelecionado,
  permissaoRecebidaSelecionada,
  idCorreios,
  idCorreiosPJ,
}) {
  const { request } = useFetch();
  const cancelar = (ev) => {
    ev.preventDefault();
    acaoCancelar();
  };

  const excluir = async () => {
    const { response } = await request(
      GRUPO_EXCLUIR(idCorreios, idCorreiosPJ, permissaoRecebidaSelecionada.id, grupoSelecionado.idGrupo),
    );

    if (response.ok) {
      abreAlertaDialog('Grupo excluido com sucesso!');
      acaoFechar();
    }
  };

  return (
    <>
      <div className="dialog-container">
        <div className="dialog-header">
          <h2>Excluir "{grupoSelecionado?.nome}"</h2>
        </div>
        <div className="dialog-main" id="dialog-main-email">
          Tem certeza de que deseja excluir esse grupo?
        </div>
        <div className="dialog-footer">
          <button className="btn-txt btn-fecha-dialog" onClick={cancelar}>
            Cancelar
          </button>
          <button className="btn-pre" id="btn-excluir" onClick={excluir}>
            Excluir
          </button>
        </div>
      </div>
    </>
  );
}
export default FormExcluirGrupo;
